import React from "react";

const MobileCheckoutBar = ({
  cartCount,
  grandTotal,
  isBasketOpen,
  onToggleBasket,
}) => {
  return (
    <div className="mobile-checkout-bar">
  <div className="mobile-checkout-bar-left">
    <div className="mobile-bar-cart-icon">
      <i className="fa fa-shopping-bag"></i>
      <span className="mobile-bar-cart-count">{cartCount}</span>
    </div>

    <div className="mobile-bar-summary">
      <span className="mobile-bar-title">Your Basket</span>
      <span className="mobile-bar-price">£{grandTotal}</span>
    </div>
  </div>

  <button className="mobile-checkout-toggle-btn" onClick={onToggleBasket}>
    <span>{isBasketOpen ? "Close" : "Open"}</span>
    <i className="fa fa-angle-right"></i>
  </button>
</div>
  );
};

export default MobileCheckoutBar;